import { Trans } from '@lingui/react/macro';
import { Typography } from '@pocketlaw/tetris';
export function ApproversHeader() {
    return (<Typography $fontSize="small" $appearance="100">
      <Trans comment="Approval pending state - Approver list title">Assigned approvers</Trans>
    </Typography>);
}
